<template>

  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Settings</li>
      </ol>
    </div>
    <div class="main-box two-column">
      <!--      sidebar setting start-->
      <sidebar></sidebar>
      <!--      sidebar setting end-->
      <div class="setting-info-wrp">
        <!-- Job Roles -->
        <div class="position-box">
          <div class="sett-head">
            <h1>Edit Job Roles</h1>
            <p>Define Job Roles that you wish to man in your schedules.</p>
          </div>
          <p>Choose a Job Roles to rename or remove it. If you choose to remove it it won't be removed from your schedules. It will only be removed from your employees and made inactive.</p>
          <div class="mb-20">
<!--            <label class="custom-check-box"><input type="checkbox"> <span class="radio-check"> Allow that employees can edit their own Job Roles </span></label>-->
          </div>
          <h2>Current Job Roles:</h2>
          <ul class="listOfJobtypes">
            <li v-for="(jobRole,key) in companyJobRoles">
              <a :href="'#java'+key" data-toggle="collapse" class="jobtypes-opener text-capitalize">
                <i class="ico ico-fill-circle" :style="'color:'+jobRole.color"></i> {{ jobRole.name }} <span class="badge badge-light">Edit</span>
              </a>
              <div class="edit-box collapse" :id="'java'+key">
                <form action="" @submit.prevent="postFormValues">
                  <div class="input_colorpicker">
                    <div class="job-colour-wrap">
                      <input type="hidden" name="job_role_id" v-model="jobRole.id" >
                      <input type="color" name="color" v-model="jobRole.color" >
                      <!--<i class="ico ico-fill-circle" :style="'color:'+jobRole.color"></i>-->
                    </div>
                    <input class="jobtype-value" name="name" :value="jobRole.name" type="text">
                    <button type="submit"  class="btn btn-sm btn-outline-info">Save</button>
                    <a href="javascript:void(0);" class="btn btn-sm btn-outline-danger" @click="removeJobRole(jobRole.id)">Romove</a>
                  </div>
                </form>

                <ul class="colors">
<!--                  <li>-->
<!--                    <input type="color" :value="jobRole.color" >-->
<!--                   </li>-->
<!--                  <li><i class="ico ico-fill-circle color-2"></i></li>
                  <li><i class="ico ico-fill-circle color-3"></i></li>
                  <li><i class="ico ico-fill-circle color-4"></i></li>
                  <li><i class="ico ico-fill-circle color-5"></i></li>
                  <li><i class="ico ico-fill-circle color-6"></i></li>
                  <li><i class="ico ico-fill-circle color-7"></i></li>
                  <li><i class="ico ico-fill-circle color-8"></i></li>
                  <li><i class="ico ico-fill-circle color-9"></i></li>
                  <li><i class="ico ico-fill-circle color-10"></i></li>
                  <li><i class="ico ico-fill-circle color-11"></i></li>
                  <li><i class="ico ico-fill-circle color-12"></i></li>
                  <li><i class="ico ico-fill-circle color-13"></i></li>
                  <li><i class="ico ico-fill-circle color-14"></i></li>
                  <li><i class="ico ico-fill-circle color-15"></i></li>
                  <li><i class="ico ico-fill-circle color-16"></i></li>-->
                </ul>
              </div>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>


</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../../router/router'
import axios from "axios";
import sidebar from "./sidebar";

export default {
  components:{
    sidebar
  },
  props: [],
  data() {
    return {
      company_id: this.$store.getters.getSelectedCompany.id,
      companyJobRoles: [],
      job_role_color:'',
      job_role_id:'',
      color:'',
      name:'',
    }
  },
  serverPrefetch() {
  },
  created() {
    this.getCompanyJobRoles();
  },
  mounted() {
    this.userSessionUpdate();
  },
  methods: {
    getCompanyJobRoles() {
      axios
        .get(this.$GetJobRulesType, {
          headers: this.getAuthHeader(),
          params: {
            company_id: this.company_id,
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            this.companyJobRoles = res.data.result;
          }
        });
    },

    removeJobRole(id){
      if (confirm("If you remove this Job Role it will be removed from your employees and deactivated")) {
        axios.post(this.$UpdateJobRolesStatus,
          {
            job_role_id: id,
            company_id: this.company_id,
            status: 0,
          }, {headers: this.getAuthHeader()})
          .then((res) => {
            if (res.status == 200) {
              this.getCompanyJobRoles()
              $root.$toast.success(res.data.message);
            }
          });
      }
    },
    postFormValues (submitEvent) {
        axios.post(this.$UpdateJobRoles,
          {
            job_role_id: submitEvent.target.elements.job_role_id.value,
            color: submitEvent.target.elements.color.value,
            name: submitEvent.target.elements.name.value,
            company_id: this.company_id,
          }, {headers: this.getAuthHeader()})
          .then((res) => {
            if (res.status == 200) {
              this.getCompanyJobRoles();
              this.userSessionUpdate();
              $root.$toast.success(res.data.message);
            }
          });
    }
  }
}
</script>
